<div class="upload-status-box">
  <h3 class="upload-status-title">UPLOAD DATA STATUS</h3>
  @for (status of dataStatuses; track status) {
    <div class="upload-status-content">
      <span class="icon-status">
        @if (!status.finished) {
          <mat-icon tabindex="1" aria-hidden="false" aria-label="Not started"
            >block
          </mat-icon>
        }
        @if (status.finished) {
          <mat-icon
            tabindex="1"
            aria-hidden="false"
            aria-label="Completed"
            class="finished"
          >
            check_circle</mat-icon
          >
        }
      </span>
      <span tabindex="1" class="type"> {{ status.type }} </span>
    </div>
  }
</div>
